document.addEventListener('DOMContentLoaded', () => {
  // ── Tabs ──────────────────────────────────────────────────────────────
  // The tab buttons are already moved into .lookbook-tabs by a synchronous
  // inline script in sections/shabibi-lookbook.liquid (runs before first
  // paint, avoiding a flash) — this just wires up click handling on them
  // wherever they now live.
  const tabs = document.querySelectorAll('[data-lookbook-tab]');
  const wrappers = document.querySelectorAll('.lookbook-drop-wrapper');
  const credits = document.querySelectorAll('[data-lookbook-credit]');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabs.forEach((t) => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');

      // The credit line lives right under its own tab (moved there by the
      // inline script in sections/shabibi-lookbook.liquid) and only shows
      // for the currently selected drop — switching tabs hides the old
      // one and reveals the new tab's own line in its place.
      credits.forEach((c) => c.classList.remove('is-active'));
      const credit = document.querySelector(`[data-lookbook-credit][data-lookbook-target="${tab.dataset.lookbookTarget}"]`);
      if (credit) credit.classList.add('is-active');

      wrappers.forEach((w) => w.classList.add('is-hidden'));
      const target = document.querySelector(`.lookbook-drop-wrapper[data-lookbook-id="${tab.dataset.lookbookTarget}"]`);
      if (target) target.classList.remove('is-hidden');
    });
  });

  // ── Lightbox ──────────────────────────────────────────────────────────
  // The real header lives in its own stacking context (#shopify-section-header
  // has position:relative + z-index:3 in layout/theme.liquid), separate from
  // #MainContent (z-index:2) where this section — and the lightbox — render.
  // Stacking contexts are compared as whole units, so no z-index on the
  // lightbox itself could ever paint over the header; it has to be hidden
  // outright instead. The lightbox has its own header row (Lookbook label +
  // logo, see the liquid markup) to replace it while open.
  const lightbox = document.querySelector('[data-lookbook-lightbox]');
  const track = document.querySelector('[data-lookbook-lightbox-track]');
  const prevBtn = document.querySelector('[data-lookbook-prev]');
  const nextBtn = document.querySelector('[data-lookbook-next]');
  const header = document.querySelector('.custom-header');
  let triggerElement = null;

  function getFocusableElements() {
    if (!lightbox) return [];
    return Array.from(lightbox.querySelectorAll('a[href], button')).filter(
      (el) => !el.hasAttribute('disabled') && el.offsetParent !== null
    );
  }

  // Keeps Tab/Shift+Tab cycling within the dialog's own controls (the home
  // logo link and the back button) instead of escaping into the page
  // behind it, which role="dialog" + aria-modal alone don't enforce.
  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    const focusable = getFocusableElements();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openLightbox(photo) {
    const wrapper = photo.closest('.lookbook-drop-wrapper');
    if (!lightbox || !track || !wrapper) return;

    // Every photo in the same drop becomes a slide, so mobile can swipe/
    // scroll through the rest of the set once the lightbox is open, not
    // just view the one that was clicked.
    const photos = Array.from(wrapper.querySelectorAll('[data-lookbook-photo]'));
    const index = photos.indexOf(photo);

    track.innerHTML = '';
    photos.forEach((p) => {
      const img = p.querySelector('img');
      if (!img) return;

      const slide = document.createElement('div');
      slide.className = 'lookbook-lightbox-slide';

      const slideImg = document.createElement('img');
      slideImg.className = 'lookbook-lightbox-img';
      slideImg.src = p.dataset.fullSrc || img.currentSrc || img.src;
      slideImg.alt = img.alt || '';
      slideImg.loading = 'lazy';
      slideImg.decoding = 'async';

      slide.appendChild(slideImg);
      track.appendChild(slide);
    });

    triggerElement = photo;
    lightbox.classList.add('is-open');
    if (header) header.classList.add('is-lightbox-hidden');

    const target = track.children[index];
    if (target) target.scrollIntoView({ block: 'nearest', inline: 'nearest' });

    const closeBtn = lightbox.querySelector('[data-lookbook-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeLightbox() {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;

    lightbox.classList.remove('is-open');
    if (header) header.classList.remove('is-lightbox-hidden');
    if (track) track.innerHTML = '';

    if (triggerElement) {
      triggerElement.focus();
      triggerElement = null;
    }
  }

  // Desktop-only affordance (hidden on touch breakpoints in CSS) — touch
  // already has swipe/scroll on the track itself. One slide's width per
  // click, same unit scroll-snap already stops the track on.
  function stepLightbox(direction) {
    if (!track) return;
    track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
  }

  if (prevBtn) prevBtn.addEventListener('click', () => stepLightbox(-1));
  if (nextBtn) nextBtn.addEventListener('click', () => stepLightbox(1));

  document.addEventListener('click', (e) => {
    const photo = e.target.closest('[data-lookbook-photo]');
    if (photo) {
      openLightbox(photo);
      return;
    }

    if (e.target.closest('[data-lookbook-close]') || e.target === lightbox) {
      closeLightbox();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      closeLightbox();
      return;
    }

    trapFocus(e);
  });
});
